import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLargeTop"><Path fillRule="evenodd" clipRule="evenodd" d="M11.9999 7.85645L22.3597 13.6119L21.3885 15.3602L11.9999 10.1444L2.61142 15.3602L1.64014 13.6119L11.9999 7.85645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeTop;
